import { APIBinderData } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation } from '../utils/helpers';

export const processGaragingAddressData = (
  binderReportData: APIBinderData,
  remarks: Remark[] = [],
  validation?: Validation,
): BinderSectionData => {
  const vehicles = binderReportData?.application_data?.vehicles || [];
  const applicantAddress =
    binderReportData?.application_data?.applicant?.address || '';
  const applicantCity =
    binderReportData?.application_data?.applicant?.city || '';
  const applicantProvince =
    binderReportData?.application_data?.applicant?.province_code || '';
  const applicantPostal =
    binderReportData?.application_data?.applicant?.postal_code || '';
  const mvrData = binderReportData?.mvr_data || [];

  // Format full address from applicant data
  const applicationAddress =
    `${applicantAddress}, ${applicantCity}, ${applicantProvince} ${applicantPostal}`.trim();

  // Process vehicle data with garaging addresses
  const processedVehicleData = vehicles.map((vehicle, index: number) => {
    // Get MVR address for this vehicle (if available)
    const mvrRecord = Array.isArray(mvrData) ? mvrData[index] : null;
    const mvrAddress = mvrRecord?.address || '';

    return {
      vehicleName:
        vehicle?.make && vehicle?.model
          ? `${vehicle.make} ${vehicle.model}${
              vehicle.model_year ? ` (${vehicle.model_year})` : ''
            }`
          : `Vehicle ${index + 1}`,
      garagingAddress: mvrAddress,
      remarks:
        remarks.find((r) => r.validation_key === '008')?.text ||
        remarks.find((r) => r.validation_key === '008a')?.text ||
        remarks.find((r) => r.validation_key === '008b')?.text,
    };
  });

  const validationData = processValidation(validation);

  return {
    title: 'Garaging address',
    description: 'Verify garaging address for each vehicle.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      vehicles: processedVehicleData,
      applicationAddress,
    },
  };
};
